import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { setIsShowBonusPriceDialog } from '../../../actions/dialog';
import s from '../../../assets/styles/style.sass';
import s2 from '../../order/Order.sass';

const tips = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
class Order16FeeBreakdown extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    orderPriceBreakdownDetail: PropTypes.shape().isRequired,
    modelDataText: PropTypes.shape().isRequired,
  };

  getTips() {
    if (this.props.currentLocale.split('-')[0].toLowerCase() === 'tw') {
      return tips.map(x => x * 2);
    }
    return tips;
  }

  render() {
    return (
      <div className={s2.fee}>
        <p className={s2.orderSmallTitle}>FEE BREAKDOWN</p>
        <hr className={s2.hrBottom} />
        <span>
          {typeof this.props.orderPriceBreakdownDetail.breakdown !== 'undefined'
            ? Object.keys(this.props.orderPriceBreakdownDetail.breakdown).map(
                (v, index) => (
                  <div key={index.toString()}>
                    <span>
                      {this.props.orderPriceBreakdownDetail.breakdown[v].title}
                    </span>
                    <span style={{ float: 'right' }}>
                      {typeof this.props.orderPriceBreakdownDetail.breakdown[v]
                        .value === 'number'
                        ? `${this.props.modelDataText.dollar_code}`
                        : ''}
                      {this.props.orderPriceBreakdownDetail.breakdown[v].value}
                    </span>
                  </div>
                ),
              )
            : ''}
        </span>
        <br />
        <br />
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  address: state.order.address,
  remark: state.order.remark,
  passengerCount: state.order.passenger_count,
  tunnel: state.order.tunnel,
  images: state.order.images,
  vehicle: state.order.vehicle,
  pickupTime: state.order.pickup_time,
  orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
  orderDetailInfo: state.order.orderDetailInfo,
});
const mapDispatch = {
  setIsShowBonusPriceDialog,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(Order16FeeBreakdown),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order16FeeBreakdown/Order16FeeBreakdown.js